var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#605E5C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0522 5.43513C11.3425 4.72539 10.1495 4.89945 9.67209 5.78239L8.14488 8.60708L5.81492 9.53552C5.65868 9.59778 5.54421 9.73442 5.51029 9.89915C5.47636 10.0639 5.52753 10.2346 5.64645 10.3536L7.29296 12.0001L5.14655 14.1465L5 15L5.85366 14.8536L8.00007 12.7072L9.64645 14.3536C9.7653 14.4724 9.9359 14.5236 10.1005 14.4898C10.2652 14.456 10.4018 14.3418 10.4642 14.1857L11.397 11.8537L14.218 10.328C15.1008 9.8505 15.2747 8.6576 14.565 7.94792L12.0522 5.43513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.a1533148e5d355e67ec326dac4b61095.svg";
export { ForwardRef as ReactComponent };